// redex/tasks/taskSelectors.js
// This assumes in store.js you named the reducer 'tasks'
// Add the '?' and '|| []' fallback

// New selector to disable the "Add" button while submitting
export const selectCreateTaskStatus = (state) => state.tasks?.createStatus || "idle";
export const selectTasksError = (state) => state.tasks?.error || null;

export const selectCreateSupportTeamTaskStatus = (state) => state.tasks?.createSupportTeamTaskStatus || "idle";
export const selectSupportTeamTaskError = (state) => state.tasks?.error || null;


export const selectTasksAssignStatus = (state) => state.tasks?.tasksAssignStatus || "idle";
export const selectTasksAssignError = (state) => state.tasks?.error || null;

export const selectTasks = (state) => state.tasks?.taskData || []; 
export const selectTasksStatus = (state) => state.tasks?.status || "idle";

// --- FIX: Access 'tasks' slice, because that is where you stored projectMenuData ---
export const selectprojectMenu = (state) => state.tasks?.projectMenuData || [];
export const selectQueryFrom = (state) => state.tasks?.queryFromData || [];

export const selectClientMenu = (state) => state.tasks?.clientMenuData || []; 
export const selectClientStatus = (state) => state.tasks?.clientStatus || "idle";


export const selectMainMenu = (state) => state.tasks?.mainMenuData || []; 
export const selectMainMenuStatus = (state) => state.tasks?.mainMenuStatus || "idle";

export const selectSubmenu1 = (state) => state.tasks?.submenu1Data || []; 
export const selectSubmenu1Status = (state) => state.tasks?.submenu1Status || "idle";

export const selectSubmenu2 = (state) => state.tasks?.submenu2Data || []; 
export const selectSubmenu2Status = (state) => state.tasks?.submenu2Status || "idle";

export const selectSubmenu3 = (state) => state.tasks?.submenu3Data || []; 
export const selectSubmenu3Status = (state) => state.tasks?.submenu3Status || "idle";

export const selectSubmenu4 = (state) => state.tasks?.submenu4Data || []; 
export const selectSubmenu4Status = (state) => state.tasks?.submenu4Status || "idle";

export const selectUpdateTaskStatus = (state) => state.tasks?.updateStatus || "idle";

export const selectCreateStatusTracker = (state) => state.tasks?.createStatusTracker || "idle";

export const selectGetTaskAssignment = (state) => state.tasks?.getTaskAssignmentData || []; 
export const selectGetTaskAssignmentStatus = (state) => state.tasks?.getTaskAssignmentStatus || "idle";

export const selectGetTaskDevelopmentList = (state) => state.tasks?.getTaskDevelopmentData || []; 
export const selectGetTaskDevelopmentListStatus = (state) => state.tasks?.getTaskDevelopmentStatus || "idle";

export const selectGetRaisedbyDetailsList = (state) => state.tasks?.getRaisedbyDetailsData || []; 
export const selectGetRaisedbyDetailsStatus = (state) => state.tasks?.getRaisedbyDetailsStatus || "idle";

export const selectLastEndTimeList = (state) => state.tasks?.getLastEndTimeData || []; 
export const selectLastEndTimeStatus = (state) => state.tasks?.getLastEndTimeStatus || "idle";

export const selectSupportTeamTaskList = (state) => state.tasks?.getSupportTeamTaskListData || []; 
export const selectSupportTeamTaskListStatus = (state) => state.tasks?.getSupportTeamTaskListStatus || "idle";

export const selectLastSyncDateTimeApiList = (state) => state.tasks?.LastSyncDateTimeApiListData || []; 
export const selectLastSyncDateTimeApiListStatus = (state) => state.tasks?.LastSyncDateTimeApiListStatus || "idle";

export const selectHistoryApiList = (state) => state.tasks?.historyListData || []; 
export const selectHistoryApiApiListStatus = (state) => state.tasks?.historyListStatus || "idle";